import {
  AppBar,
  Box,
  Container,
  Button,
  Grid,
  Hidden,
  Paper,
  Tab,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Tabs,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useParams } from "react-router-dom";
import CancelIcon from "@mui/icons-material/Cancel";
import { makeStyles } from "@mui/styles";
import { PropTypes } from "prop-types";
import React, { useState, useEffect, useContext } from "react";
import SwipeableViews from "react-swipeable-views";
import Loader from "../../sharedComponents/loader/loader";
import BasicStats from "./BasicStats";
import AdvanceStats from "./AdvanceStats";
import { AppDataContext } from "../../common/appContext";
import _without from "lodash/without";
import Chip from "@mui/material/Chip";
import { handleError } from "../../helper";
import { PlayerProfileService } from "../../services/playerProfile.Service";
import { exportDataToExcel } from "../../sharedComponents/CustomExportToExcel";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
//import { useNavigate } from "react-router-dom";
//import RouteConstants from "../../common/RouteConstants";
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
function getStyles1(name, pName, theme) {
  return {
    fontWeight:
      pName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

const useStyles = makeStyles((theme) => ({
  bgBlue: {
    height: "131vh",
    background:
      "-webkit-linear-gradient(top, #1d428a 230px, #f6f6f6 20px, #f6f6f6 21px, #f6f6f6 10rem, #f6f6f6 100%)",
  },
  title: {
    flexGrow: 1,
    fontSize: "1.1rem",
    fontWeight: "450",
  },
  appbarBackground: {
    backgroundColor: "#fff",
    color: "#1d428a",
  },
  backButton: {
    backgroundColor: "white",
    minWidth: "50px",
    "&:hover": {
      backgroundColor: "white",
    },
    textTransform: "none",
    border: "1px solid lightgrey",
    boxShadow: "1px 1px 3px 1px lightgrey",
  },
  actionButtons: {
    padding: "0px 12px 0px 10px",
    height: "40px",
  },
  appbar: {
    backgroundColor: "#f5f5f5",
    color: "#000000",
    "& .Mui-selected": {
      color: theme.palette.primary.main,
    },
  },
  paperStyle: {
    // height: "calc(100vh - 149px)",
    // height: "120vh",
  },
  exportToExcel: {
    backgroundColor: "white",
    minWidth: "50px",
    "&:hover": {
      backgroundColor: "white",
    },
  },
  excelButton: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    flex: "1",
    paddingRight: theme.spacing(1),
  },
}));
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
var positionCount = 0;
var nextIdSuffix = 1;
const season = [
  "2022",
  "2021",
  "2020",
  "2019",
  "2018",
  "2017",
  "2016",
  "2015",
  "2014",
  "2013",
  "2012",
  "2011",
  "2010",
];

export default function CareerStatsDashboard() {
  const classes = useStyles();
  const idRef = React.useRef();
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  //const navigate = useNavigate();
  const {
    user,
    selectedEventId,
    getActiveEventId,
    selectedCareerStatsTab,
    combineYear,
  } = useContext(AppDataContext);
  const [eventId, setEventId] = useState(selectedEventId);
  const params = useParams();
  //const [eventId, setEventId] = useState(params.eventId);
  const [personName, setPersonName] = React.useState("");
  const [personsName, setPersonsName] = React.useState([]);
  var year = combineYear - 1;
  var seasonYear = "" + year;

  const [pName, setPName] = React.useState([]);
  const [mseason, setMSeason] = React.useState([seasonYear]);
  const [sName, setSName] = React.useState([seasonYear]);
  const [spid, setSpid] = React.useState();
  const [list, setList] = useState([]);
  const [selectedTab, setSelectedTab] = useState(selectedCareerStatsTab);
  //const [listAdvance, setListAdvance] = useState([]);
  const [excelClick, setExcelClick] = useState(false);
  const [playerName, setplayerName] = useState([]);
  const [positionName, setPositionName] = useState([]);
  const [priamryPlayerData, setpriamryPlayerData] = React.useState([]);
  const [perenctileRank, setperenctileRank] = React.useState([]);
  const [otherPlayerData, setotherPlayerData] = React.useState([]);
  const [groupAvg, setgroupAvg] = React.useState([]);

  //#NEW EXCEL LIBRARY
  const exportToExcelHandler = async () => {
    const sheetsData = [
      {
        sheetName: "Basic Stats",
        tables: getBasicStatsTablesForData(),
      },
      {
        sheetName: "Advance Stats",
        tables: getAdvanceStatsTablesForData(),
      },
    ];

    await exportDataToExcel(sheetsData, "Career Stats");
  };

  const getBasicStatsTablesForData = () => {
    const styleHeaderCss = {
      fill: {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "e6eefb" },
      },
      font: { sz: "11", bold: true, color: { rgb: "1d428a" } },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: {
        wrapText: true,
        horizontal: "center",
        vertical: "top",
      },
    };

    return [
      {
        title: "",
        headerNames: [
          {
            title: `Player Name`,
            width: 40,
            style: styleHeaderCss,
          },
          {
            title: `Position`,
            width: 40,
            style: styleHeaderCss,
          },
          {
            title: `Season`,
            width: 40,
            style: styleHeaderCss,
          },
          {
            title: `GP`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `GS`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `MIN`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `FGM`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `FGA`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `FG%`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `2PM`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `2PA`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `2P%`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `3PM`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `3PA`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `3P%`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `FTM`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `FTA`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `FT%`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `ORB`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `DRB`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `REB`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `AST`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `TO`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `STL`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `BLK`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `PF`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `TF`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `PTS`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `FF`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `TS%`,
            width: 20,
            style: styleHeaderCss,
          },
        ],
        data:
          list?.length > 0
            ? list.map((record) => ({
                playerName: record.playerName ? record.playerName : "",
                position: record.position ? record.position : "",
                seasonYear: record.seasonYear ? record.seasonYear : "",
                gamesPlayed: record.gamesPlayed ? record.gamesPlayed : "",
                gamesStarted: record.gamesStarted ? record.gamesStarted : "",
                minutes: record.minutes ? record.minutes : "",
                fieldGoalsMade: record.fieldGoalsMade
                  ? record.fieldGoalsMade
                  : "",
                fieldGoalsAtt: record.fieldGoalsAtt ? record.fieldGoalsAtt : "",
                fieldGoalsPct: record.fieldGoalsPct
                  ? parseInt(record.fieldGoalsPct * 100)
                  : "",
                twoPointsMade: record.twoPointsMade ? record.twoPointsMade : "",
                twoPointsAtt: record.twoPointsAtt ? record.twoPointsAtt : "",
                twoPointsPct: record.twoPointsPct
                  ? parseInt(record.twoPointsPct * 100)
                  : "",
                threePointsMade: record.threePointsMade
                  ? record.threePointsMade
                  : "",
                threePointsAtt: record.threePointsAtt
                  ? record.threePointsAtt
                  : "",
                threePointsPct: record.threePointsPct
                  ? parseInt(record.threePointsPct * 100)
                  : "",
                freeThrowsMade: record.freeThrowsMade
                  ? record.freeThrowsMade
                  : "",
                freeThrowsAtt: record.freeThrowsAtt ? record.freeThrowsAtt : "",
                freeThrowsPct: record.freeThrowsPct
                  ? parseInt(record.freeThrowsPct * 100)
                  : "",
                offensiveRebounds: record.offensiveRebounds
                  ? record.offensiveRebounds
                  : "",
                defensiveRebounds: record.defensiveRebounds
                  ? record.defensiveRebounds
                  : "",
                rebounds: record.rebounds ? record.rebounds : "",
                assists: record.assists ? record.assists : "",
                turnovers: record.turnovers ? record.turnovers : "",
                steals: record.steals ? record.steals : "",
                blocks: record.blocks ? record.blocks : "",
                personalFouls: record.personalFouls ? record.personalFouls : "",
                techFouls: record.techFouls ? record.techFouls : "",
                points: record.points ? record.points : "",
                flagrantFouls: record.flagrantFouls ? record.flagrantFouls : "",
                trueShootingPct: record.trueShootingPct
                  ? parseInt(record.trueShootingPct * 100)
                  : "",
              }))
            : [],
        columnStyles: Array(30).fill({
          font: { size: 11 },
          border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          },
          alignment: {
            horizontal: "center",
            vertical: "middle",
          },
        }),
      },
    ];
  };

  const getAdvanceStatsTablesForData = () => {
    const styleHeaderCss = {
      fill: {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "e6eefb" },
      },
      font: { sz: "11", bold: true, color: { rgb: "1d428a" } },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: {
        wrapText: true,
        horizontal: "center",
        vertical: "top",
      },
    };

    return [
      {
        title: "",
        headerNames: [
          {
            title: `Player Name`,
            width: 40,
            style: styleHeaderCss,
          },
          {
            title: `Position`,
            width: 40,
            style: styleHeaderCss,
          },
          {
            title: `Season`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `TS%`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `eFG%`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `3PA`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `FTr`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `ORB%`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `DRB%`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `TRB%`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `AST%`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `STL%`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `BLK%`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `TOV%`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `USG%`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `ORtg`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `DRtg`,
            width: 20,
            style: styleHeaderCss,
          },
        ],
        data:
          list?.length > 0
            ? list?.map((record) => ({
                playerName: record.playerName ? record.playerName : "",
                position: record.position ? record.position : "",
                seasonYear: record.seasonYear ? record.seasonYear : "",
                tS_Pct: record.tS_Pct ? record.tS_Pct : "",
                eFG_Pct: record.eFG_Pct ? record.eFG_Pct : "",
                threePAr: record.threePAr ? record.threePAr : "",
                fTr: record.fTr ? record.fTr : "",
                orB_Pct: record.orB_Pct ? record.orB_Pct : "",
                drB_Pct: record.drB_Pct ? record.drB_Pct : "",
                trB_Pct: record.trB_Pct ? record.trB_Pct : "",
                asT_Pct: record.asT_Pct ? record.asT_Pct : "",
                stL_Pct: record.stL_Pct ? record.stL_Pct : "",
                blK_Pct: record.blK_Pct ? record.blK_Pct : "",
                toV_Pct: record.toV_Pct ? record.toV_Pct : "",
                usG_Pct: record.usG_Pct ? record.usG_Pct : "",
                oRtg: record.oRtg ? record.oRtg : "",
                dRtg: record.dRtg ? record.dRtg : "",
              }))
            : [],
        columnStyles: Array(17).fill({
          font: { size: 11 },
          border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          },
          alignment: {
            horizontal: "center",
            vertical: "middle",
          },
        }),
      },
    ];
  };

  if (!idRef.current) {
    idRef.current = `CustomSelect${nextIdSuffix}`;
    nextIdSuffix++;
  }
  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleChangeIndex = (index) => {
    setSelectedTab(index);
  };

  const handleChangePlayer = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(value);

    setSpid(value);
    obj["primaryPlayerId"] = value;
    if (personsName !== null) {
      obj["otherPlayerId"] = personsName;
    } else {
      obj["otherPlayerId"] = [];
    }
    if (mseason === null) {
      obj["season"] = null;
    } else {
      obj["season"] = mseason;
    }
    if (pName === null) {
      obj["position"] = null;
    } else {
      obj["position"] = pName;
    }
    GetAllPlayersStats();
    GetAllPlayersStatsPercentile();
  };

  const handleChangePerson = (event) => {
    const {
      target: { value },
    } = event;
    setPersonsName(typeof value === "string" ? value.split(",") : value);
    if (spid !== null) {
      obj["primaryPlayerId"] = spid;
    } else {
      obj["primaryPlayerId"] = 1;
    }
    if (mseason === null) {
      obj["season"] = null;
    } else {
      obj["season"] = mseason;
    }
    if (pName === null) {
      obj["position"] = null;
    } else {
      obj["position"] = pName;
    }
    obj["otherPlayerId"] = value;
    GetAllPlayersStats();
    GetAllPlayersStatsPercentile();
  };

  const handleChangePosition = (event) => {
    setLoading(true);
    const {
      target: { value },
    } = event;
    positionCount = positionCount + 1;
    setPName(value);
    if (spid !== null) {
      obj["primaryPlayerId"] = spid;
    } else {
      obj["primaryPlayerId"] = 1;
    }
    if (mseason === null) {
      obj["season"] = null;
    } else {
      obj["season"] = mseason;
    }
    if (personsName !== null) {
      obj["otherPlayerId"] = personsName;
    } else {
      obj["otherPlayerId"] = [];
    }
    obj["position"] = value;
    GetAllPlayersStats();
    GetAllPlayersStatsPercentile();
  };

  const handleChangeSeason = (event) => {
    const {
      target: { value },
    } = event;
    setSName(value);
    setMSeason(value);
    obj["season"] = value;
    if (spid !== null) {
      obj["primaryPlayerId"] = spid;
    } else {
      obj["primaryPlayerId"] = 1;
    }

    if (personsName !== null) {
      obj["otherPlayerId"] = personsName;
    } else {
      obj["otherPlayerId"] = [];
    }
    if (pName === null) {
      obj["position"] = null;
    } else {
      obj["position"] = pName;
    }

    GetAllPlayersStats();
    GetAllPlayersStatsPercentile();
  };

  function getseasonAfterdelete(value) {
    var newseason = mseason.filter((seasonVal) => {
      return seasonVal !== value;
    });
    setMSeason(newseason);
    if (newseason.length === 0) {
      obj["season"] = null;
    } else {
      obj["season"] = newseason;
    }
    if (spid !== null) {
      obj["primaryPlayerId"] = spid;
    } else {
      obj["primaryPlayerId"] = 1;
    }
    if (personsName !== null) {
      obj["otherPlayerId"] = personsName;
    } else {
      obj["otherPlayerId"] = [];
    }
    if (pName === null) {
      obj["position"] = null;
    } else {
      obj["position"] = pName;
    }

    GetAllPlayersStats();
    GetAllPlayersStatsPercentile();
  }

  var allPalyerData = [];
  function getpositionAfterdelete(value) {
    var newposition = pName.filter((posVal) => {
      return posVal !== value;
    });
    setPName(newposition);
    if (newposition.length === 0) {
      obj["position"] = null;
    } else {
      obj["position"] = newposition;
    }
    if (spid !== null) {
      obj["primaryPlayerId"] = spid;
    } else {
      obj["primaryPlayerId"] = 1;
    }
    if (personsName !== null) {
      obj["otherPlayerId"] = personsName;
    } else {
      obj["otherPlayerId"] = [];
    }
    if (mseason === null) {
      obj["season"] = null;
    } else {
      obj["season"] = mseason;
    }
    GetAllPlayersStats();
    GetAllPlayersStatsPercentile();
  }

  function getpersonAfterdelete(value) {
    var newperson = personsName.filter((seasonVal) => {
      return seasonVal !== value;
    });

    setPersonsName(newperson);
    if (newperson.length === 0) {
      obj["otherPlayerId"] = null;
    } else {
      obj["otherPlayerId"] = newperson;
    }
    if (spid !== null) {
      obj["primaryPlayerId"] = spid;
    } else {
      obj["primaryPlayerId"] = 1;
    }
    if (mseason === null) {
      obj["season"] = null;
    } else {
      obj["season"] = mseason;
    }
    if (pName === null) {
      obj["position"] = null;
    } else {
      obj["position"] = pName;
    }
    GetAllPlayersStats();
    GetAllPlayersStatsPercentile();
  }

  useEffect(() => {
    setEventId(selectedEventId);
    setPName([]);
    setSpid(10000);
    setPersonName("");
    var newYear = combineYear - 1;
    var newYearSeason = "" + newYear;
    setMSeason([newYearSeason]);
    setSName([newYearSeason]);
  }, [selectedEventId]);

  useEffect(() => {
    if (eventId !== 0 && user && user.loginID) {
      setLoading(true);
      GetAllPlayers();
      GetAllPlayersStats();
      GetAllPlayersStatsPercentile();
      GetAllPositions();
    } else {
      setLoading(true);

      // getActiveEventId();
    }
  }, [user, eventId]);
  useEffect(() => {
    if (excelClick) {
      document.getElementById("careerstats-list-excel-export").click();
      setExcelClick(false);
    }
  }, [excelClick]);

  var obj = {
    eventId: "" + eventId,
    primaryPlayerId: 0,
    otherPlayerId: null,
    season: [seasonYear],
    position: null,
  };

  const GetAllPlayersStats = async () => {
    setLoading(true);
    setpriamryPlayerData([]);
    setotherPlayerData([]);
    setList([]);
    setgroupAvg([]);
    PlayerProfileService.getPalyerStatsdata(obj)
      .then((result) => {
        var completeotherplayer = [];
        setpriamryPlayerData(result.data.primaryPlayer);
        completeotherplayer = [
          ...result.data.otherPlayer,
          ...result.data.otherPlayerAvg,
        ];
        setotherPlayerData(completeotherplayer);
        allPalyerData = [...result.data.primaryPlayer, ...completeotherplayer];
        setList(allPalyerData);

        setgroupAvg(result.data.otherPlayerAvg);
        setLoading(false);
        return result;
      })
      .catch(handleError);
    setLoading(false);
  };

  const GetAllPlayersStatsPercentile = async () => {
    setLoading(true);
    PlayerProfileService.getPalyerStatsdataPercentile(obj)
      .then((result) => {
        setperenctileRank(result.data);
        setLoading(false);
        return result;
      })
      .catch(handleError);
    setLoading(false);
  };

  const GetAllPlayers = async () => {
    setLoading(true);
    PlayerProfileService.getPlayerListByEventIdYear(eventId, user?.loginID)
      .then((result) => {
        setplayerName(result.data);
        setLoading(false);
        return result;
      })
      .catch(handleError);
    setLoading(false);
  };

  const GetAllPositions = async () => {
    setLoading(true);
    PlayerProfileService.getPlayerPositions()
      .then((result) => {
        var playingPosition = [];
        for (var i = 0; i < result.data.length; ++i) {
          if (
            result.data[i].childName === "C" ||
            result.data[i].childName === "G" ||
            result.data[i].childName === "F"
          )
            playingPosition = [...playingPosition, result.data[i].childName];
        }
        var sortedpos = playingPosition.sort(function (a, b) {
          return a.localeCompare(b); //using String.prototype.localCompare()
        });
        setPositionName(sortedpos);
        setPositionName(playingPosition);
        setLoading(false);
        return result;
      })
      .catch(handleError);
    setLoading(false);
  };

  const handleDeletePosition = (e, value) => {
    e.preventDefault();
    setPName((current) => _without(current, value));
    getpositionAfterdelete(value);
  };

  const handleDeleteSeason = (e, value) => {
    e.preventDefault();
    setSName((current) => _without(current, value));
    getseasonAfterdelete(value);
  };

  const handleDeletePerson = (e, value) => {
    e.preventDefault();
    setPersonsName((current) => _without(current, value));
    getpersonAfterdelete(value);
  };

  return (
    <>
      <Container maxWidth={false}>
        <Loader isLoading={loading} />
        <Grid container mt={2} mb={2} columnGap={5}>
          <Grid item lg={2} sm={3} xs={6}>
            <Typography>Selected Player</Typography>

            <FormControl sx={{ m: 1 }} size="small" fullWidth>
              <InputLabel id="demo-multiple-chip-label"> Name</InputLabel>
              <Select
                labelId="demo-multiple-chip-label"
                id="demo-multiple-chip"
                value={personName}
                onChange={handleChangePlayer}
                input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                MenuProps={MenuProps}
              >
                {playerName.map((name, index) => (
                  <MenuItem
                    key={name.playerID}
                    value={name.playerID}
                    //style={getStyles(name.playerID, personName, theme)}
                  >
                    {name.playerName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item lg={2} sm={3} xs={6}>
            <Typography>Season</Typography>

            <FormControl sx={{ m: 1 }} size="small" fullWidth>
              <InputLabel id="demo-multiple-chip-label-season">
                Season
              </InputLabel>
              <Select
                labelId="demo-multiple-chip-label-season"
                id="demo-multiple-chip-season"
                multiple
                value={sName}
                onChange={handleChangeSeason}
                input={
                  <OutlinedInput
                    id="select-multiple-chip-seasson"
                    label="Chip"
                  />
                }
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((value, index) => (
                      <Chip
                        key={index}
                        label={value}
                        clickable
                        onDelete={(e) => {
                          handleDeleteSeason(e, value);
                        }}
                        deleteIcon={
                          <CancelIcon
                            onMouseDown={(event) => event.stopPropagation()}
                          />
                        }
                        // onDelete={(e) => handleDelete(e, value)}
                        // onClick={(e) => handleDelete(e, value)}
                      />
                    ))}
                  </Box>
                )}
                MenuProps={MenuProps}
              >
                {season.map((name, index) => (
                  <MenuItem
                    key={index}
                    value={name}
                    style={getStyles1(name, pName, theme)}
                  >
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item lg={2} sm={3} xs={6}>
            <Typography>Select Position</Typography>

            <FormControl sx={{ m: 1 }} size="small" fullWidth>
              <InputLabel id="demo-multiple-chip-label-pos">
                Position
              </InputLabel>
              <Select
                labelId="demo-multiple-chip-label-pos"
                id="demo-multiple-chip-pos"
                multiple
                value={pName}
                onChange={handleChangePosition}
                input={
                  <OutlinedInput id="select-multiple-chip-pos" label="Chip" />
                }
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((value, index) => (
                      <Chip
                        key={index}
                        label={value}
                        clickable
                        onDelete={(e) => {
                          handleDeletePosition(e, value);
                        }}
                        deleteIcon={
                          <CancelIcon
                            onMouseDown={(event) => event.stopPropagation()}
                          />
                        }
                        // onDelete={(e) => handleDelete(e, value)}
                        // onClick={(e) => handleDelete(e, value)}
                      />
                    ))}
                  </Box>
                )}
                MenuProps={MenuProps}
              >
                {positionName.map((name, index) => (
                  <MenuItem
                    key={index}
                    value={name}
                    style={getStyles1(name, pName, theme)}
                  >
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container mt={2} mb={2} columnGap={5}>
          <Grid item lg={6.7} sm={10.2} xs={10.2}>
            <Typography>Select Other Players For Comparison</Typography>

            <FormControl sx={{ m: 1 }} size="small" fullWidth>
              <InputLabel id="demo-multiple-chip-label-splayer">
                Names
              </InputLabel>
              <Select
                labelId="demo-multiple-chip-label-splayer"
                id="demo-multiple-chip-splayer"
                multiple
                value={personsName}
                onChange={handleChangePerson}
                input={
                  <OutlinedInput
                    id="select-multiple-chip-splayer"
                    label="Chip"
                  />
                }
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((value, index) => {
                      var pname = playerName.map((val, k) => {
                        if (val.playerID === value) {
                          return val.playerName;
                        }
                      });
                      return (
                        <Chip
                          key={index}
                          label={pname} //{playerName[value - 1].playerName}
                          clickable
                          onDelete={(e) => {
                            handleDeletePerson(e, value);
                          }}
                          deleteIcon={
                            <CancelIcon
                              onMouseDown={(event) => event.stopPropagation()}
                            />
                          }
                          // onDelete={(e) => handleDelete(e, value)}
                          // onClick={(e) => handleDelete(e, value)}
                        />
                      );
                    })}
                  </Box>
                )}
                MenuProps={MenuProps}
              >
                {playerName.map((name, index) => (
                  <MenuItem
                    key={name.playerID}
                    value={name.playerID}

                    //style={getStyles(name.playerID, personName, theme)}
                  >
                    {name.playerName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Grid container pt={2} pb={2}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container>
              <Grid item lg xs={12}>
                <Paper
                  elevation={8}
                  sx={{
                    borderRadius: "16px",
                  }}
                >
                  <Box
                    component="div"
                    display="flex"
                    flexGrow={1}
                    flexDirection="column"
                    className={classes.paperStyle}
                  >
                    <AppBar
                      position="static"
                      className={classes.appbar}
                      sx={{
                        borderTopLeftRadius: "15px !important",
                        borderTopRightRadius: "15px !important",
                      }}
                    >
                      <Hidden mdUp>
                        <Tabs
                          scrollButtons
                          allowScrollButtonsMobile
                          value={selectedTab}
                          onChange={handleChange}
                          indicatorColor="primary"
                          textColor="inherit"
                          variant="scrollable"
                          aria-label="full width tabs example"
                          // selectionFollowsFocus
                        >
                          <Tab
                            sx={{ textTransform: "none" }}
                            label="Basic Stats"
                            {...a11yProps(0)}
                          />
                          <Tab
                            sx={{ textTransform: "none" }}
                            label="Advanced Stats"
                            {...a11yProps(1)}
                          />
                          <Box className={classes.excelButton}>
                            <Button
                              size="small"
                              className={classes.exportToExcel}
                              title="Export to Excel"
                              sx={{
                                border: "1px solid lightgrey",
                                boxShadow: "1px 1px 3px black",
                                minWidth: "auto !important",
                              }}
                              onClick={exportToExcelHandler}
                            >
                              <img
                                alt="pngImg"
                                src="../../../../playerProfile/excel.png"
                                width="26"
                                height="26"
                              />
                            </Button>
                          </Box>
                        </Tabs>
                      </Hidden>
                      <Hidden mdDown>
                        <Tabs
                          scrollButtons
                          allowScrollButtonsMobile
                          value={selectedTab}
                          onChange={handleChange}
                          indicatorColor="primary"
                          textColor="inherit"
                          variant="standard"
                          aria-label="full width tabs example"
                        >
                          <Tab
                            sx={{ textTransform: "none" }}
                            label="Basic Stats"
                            {...a11yProps(0)}
                          ></Tab>
                          <Tab
                            sx={{ textTransform: "none" }}
                            label="Advanced Stats"
                            {...a11yProps(1)}
                          />
                          <Box className={classes.excelButton}>
                            <Button
                              size="small"
                              className={classes.exportToExcel}
                              title="Export to Excel"
                              sx={{
                                border: "1px solid lightgrey",
                                boxShadow: "1px 1px 3px black",
                                minWidth: "auto !important",
                              }}
                              onClick={exportToExcelHandler}
                            >
                              <img
                                alt="pngImg"
                                src="../../../../playerProfile/excel.png"
                                width="26"
                                height="26"
                              />
                            </Button>
                          </Box>
                        </Tabs>
                      </Hidden>
                    </AppBar>
                    <SwipeableViews
                      className={classes.swipeView}
                      axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                      index={selectedTab}
                      onChangeIndex={handleChangeIndex}
                    >
                      {/* Tab 1 */}
                      <TabPanel
                        value={selectedTab}
                        index={0}
                        dir={theme.direction}
                      >
                        <BasicStats
                          setLoading={setLoading}
                          priamryPlayerData={priamryPlayerData}
                          otherPlayerData={otherPlayerData}
                          groupAvg={groupAvg}
                          perenctileRank={perenctileRank}
                          primaryName={
                            priamryPlayerData && priamryPlayerData.length > 0
                              ? priamryPlayerData[0].playerName
                              : "Selected Player"
                          }
                          eventId={eventId}
                          selectedSeasons={sName}
                        />
                      </TabPanel>
                      {/* Tab 2 */}
                      <TabPanel
                        value={selectedTab}
                        index={1}
                        dir={theme.direction}
                      >
                        <AdvanceStats
                          setLoading={setLoading}
                          priamryPlayerData={priamryPlayerData}
                          otherPlayerData={otherPlayerData}
                          groupAvg={groupAvg}
                          perenctileRank={perenctileRank}
                          primaryName={
                            priamryPlayerData && priamryPlayerData.length > 0
                              ? priamryPlayerData[0].playerName
                              : "Selected Player"
                          }
                          eventId={eventId}
                          selectedSeasons={sName}
                        />
                      </TabPanel>
                    </SwipeableViews>
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
